import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Divider from '@components/Divider';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { makeItemKey } from '@utils/orderUtils';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import OrderItemRow from './OrderItemRow';

/** 주문 상품 목록 */
function OrderItems() {
    const { orderLines } = useCalculatedRequest();
    const { t } = useTranslation('order');
    return (
        <Accordion initialOpen
            title={(
                <Row align='center' spacing={2}>
                    <Text fontWeight='medium' color={colors.textPrimary}>
                        {t('items.title')}
                    </Text>
                    <Text color={colors.textUnselected}>
                        {t('items.totalCount', { count: orderLines.length })}
                    </Text>
                </Row>
            )}>
            <Column fullWidth spacing={6}>
                {orderLines.map((line, index) => (
                    <Fragment key={`${makeItemKey(line)}-${line.shopItemId}`}>
                        {index !== 0 && <Divider isThin />}
                        <OrderItemRow line={line} />
                    </Fragment>
                ))}
            </Column>
        </Accordion>
    );
}

export default OrderItems;
